<template>
  <div class="order" :style="height_topdom">
    <div class="order_nav" :style="height_navdom" ref="orderNav">
      <navbar
        title="订单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
      <div class="search_pro">
        <van-search
          v-model="searchName"
          placeholder="请输入要搜索的订单编号/商品名"
        />
      </div>
    </div>
    <div class="all" :style="height_thisdom">
      <van-tabs
        sticky
        @click="onClick"
        v-model="active"
        scroll="{ scrollTop: 64, isFixed: true }"
      >
        <van-tab
          title="待发货"
          name="0"
          style="padding-bottom: 6.45rem; box-sizing: border-box"
        >
          <allOrder
            v-if="active == 0"
            orderStyle="20"
            :gooodsName="searchName"
          />
        </van-tab>
        <van-tab title="已发货" name="1">
          <allOrder
            v-if="active == 1"
            orderStyle="30"
            :gooodsName="searchName"
          />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import allOrder from "./allOrder.vue";
export default {
  components: {
    navbar,
    allOrder,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      // righticon: require("@/assets/purchaseSupplier/common/search.png"),
      active: 0,
      searchName: "",
      height_thisdom: {
        // height:'',
        // height : ( document.body.clientHeight - 142)/ (document.body.clientWidth / 375)/ 10 + "rem"
      },
      height_topdom: {
        height: document.body.clientHeight / (document.body.clientWidth / 375) / 10 +
          "rem",
      },
      height_navdom: {
        height:''
        // height: 142 / (document.body.clientWidth / 375) / 10 + "rem",
      },
    };
  },
  created() {
    if (localStorage.getItem("orderLabel")) {
      this.active = localStorage.getItem("orderLabel");
    }
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    this.$nextTick(()=>{
      let NavH = (document.body.clientWidth / 375) * 10 * 8.8 + 54;
      this.height_thisdom.height = ( document.body.clientHeight - NavH)/ (document.body.clientWidth / 375)/ 10 + "rem";
      // this.height_navdom.height = (NavH) / (document.body.clientWidth / 375) / 10 + "rem";
    })
  },
  methods: {
    goBack() {
      localStorage.removeItem("orderLabel");
      if (this.$route.query.from) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/purchaseSupplier/index");
      }
    },
    onClick(name) {
      this.active = name;
      localStorage.setItem("orderLabel", name);
    },
    // toSearch() {
    //   this.$router.push("/purchaseSupplier/searchOrder");
    // },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .order_nav {
    // position: fixed;
    // top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    // padding-top: var(--status-height);
    z-index: 3;
    box-sizing: border-box;
  }

  .all {
    flex: 1;
    // padding-top: 14.2rem;
    box-sizing: border-box;
    height: 100%;
    // position: fixed;
    // bottom: 0;
    width: 100%;
    z-index: 4;

    /deep/.van-tabs {
      min-height: 100%;

      .van-sticky {
        position: fixed;
        // top: calc(var(--sizeScale2) * 142px);
        // top: 14.2rem;
        // top :142 / (document.body.clientWidth / 375) / 10 + "rem";
        width: 100%;
        z-index: 2;

        .van-tab {
          font-size: 1.4rem;
          color: #999;
          font-weight: 400;
          padding: 0 0.8rem;
        }

        .van-tab--active {
          color: #333;
          font-weight: 700;
        }

        .van-tabs__line {
          background: -webkit-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
          width: 9.8rem;
          height: 0.3rem;
        }
      }
    }
  }
}
</style>

